/**
 * Duration type dropdown — shared by Infrastructure Leasing list-asset and post-requirement
 * (`/infrastructure-leasing/list-asset`, `/infrastructure-leasing/post-requirement`).
 */
export const DURATION_TYPE_OPTIONS = [
  { value: 'days', label: 'Days (Short-term)' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
  { value: 'years', label: 'Years (Long-term)' },
];
